import React from 'react';
import { Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import HomeIcon from '@mui/icons-material/Home';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import SettingsIcon from '@mui/icons-material/Settings';
// import RestartAltIcon from '@mui/icons-material/RestartAlt';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

export default function NavigationButtons() {

  const location = useLocation();

  return (
    <Box sx={{
      // textAlign: 'left',
      // paddingBottom: '10px',
      // fontSize: '0.8em',
      // display: 'flex',
      // justifyContent: 'space-between',
    }}>
      <Box sx={{
        // textAlign: 'left',
        // paddingBottom: '10px',
        // fontSize: '0.8em',
        display: 'flex',
        justifyContent: 'space-between',
        // paddingBottom: '20px',
        marginTop: '10px',
        paddingBottom: 0,
        paddingLeft: '10px',
        paddingRight: '10px',
      }}>
        {/* <Box>
        <ArrowBackIosIcon />
      </Box>
      <Box>
        <ArrowForwardIosIcon />
      </Box> */}

        <Box>
          <Link to={'/home'}>
            <HomeIcon
              fontSize={'large'}
              sx={{
                color: location.pathname == '/' ||
                  location.pathname == '/settings' ||
                  location.pathname == '/profile' ||
                  location.pathname == '/home' ||
                  location.pathname == '/about' ||
                  location.pathname == '/privacy-statement' ||
                  location.pathname == '/help'
                  ? '#FFFFFF' : '#3B4E68',
              }}
            />
          </Link>
        </Box>

        {/* location.pathname == '/settings' ? sx = {{color: '#FFFFFF'}} :sx={{ color: '#000000' }} */}

        <Box>
          <Link to={'/profile'}>
            <PersonOutlineIcon
              fontSize={'large'}
              sx={{
                color: location.pathname == '/' ||
                  location.pathname == '/settings' ||
                  location.pathname == '/profile' ||
                  location.pathname == '/home' ||
                  location.pathname == '/about' ||
                  location.pathname == '/privacy-statement' ||
                  location.pathname == '/help'
                  ? '#FFFFFF' : '#3B4E68',
              }}
            />
          </Link>
        </Box>
        <Box>
          <Link to={'/register-pattern'}>
            <AppRegistrationIcon
              fontSize={'large'}
              sx={{
                color: location.pathname == '/' ||
                  location.pathname == '/settings' ||
                  location.pathname == '/profile' ||
                  location.pathname == '/home' ||
                  location.pathname == '/about' ||
                  location.pathname == '/privacy-statement' ||
                  location.pathname == '/help'
                  ? '#FFFFFF' : '#3B4E68',
              }}
            />
          </Link>
        </Box>
        {/* <Box>
          <Link to={'/reset'}>
            <RestartAltIcon fontSize={'large'} />
          </Link>
        </Box> */}
        <Box>
          <Link to={'/challenge'}>
            <VpnKeyIcon
              fontSize={'large'}
              sx={{
                color: location.pathname == '/' ||
                  location.pathname == '/settings' ||
                  location.pathname == '/profile' ||
                  location.pathname == '/home' ||
                  location.pathname == '/about' ||
                  location.pathname == '/privacy-statement' ||
                  location.pathname == '/help'
                  ? '#FFFFFF' : '#3B4E68',
              }}
            />
          </Link>
        </Box>
        <Box>
          <Link to={'/settings'}>
            <SettingsIcon
              fontSize={'large'}
              sx={{
                color: location.pathname == '/' ||
                  location.pathname == '/settings' ||
                  location.pathname == '/profile' ||
                  location.pathname == '/home' ||
                  location.pathname == '/about' ||
                  location.pathname == '/privacy-statement' ||
                  location.pathname == '/help'
                  ? '#FFFFFF' : '#3B4E68',
              }}
            />
          </Link>
        </Box>
      </Box >
    </Box>
  );

}